import { displayErrorToast } from "@endya-conformite/ui-kit";
import { handleGatewayError } from "@src/api/utils/handleGatewayError";
import { userSession } from "@src/session/UserSession";
import { AxiosResponse } from "axios";

const defaultOptions = {
  type: "application/pdf",
};

export function downloadFile(
  fileOrUrl: ArrayBuffer | Blob,
  filename: string,
  options?: typeof defaultOptions
): void;

export function downloadFile(
  fileOrUrl: string,
  options?: typeof defaultOptions
): void;

export function downloadFile(
  fileOrUrl: ArrayBuffer | Blob | string,
  filenameOrOptions?: string | typeof defaultOptions,
  providedOptions: typeof defaultOptions = defaultOptions
): void {
  let fileUrl: string;
  let filename: string;
  let options = providedOptions;

  if (typeof fileOrUrl === "string") {
    fileUrl = fileOrUrl;
    filename = fileOrUrl.split("/").pop() || "download";
    options = filenameOrOptions as typeof defaultOptions;
  } else {
    filename = filenameOrOptions as string;
    const fileToDownload = new Blob([fileOrUrl], options);
    fileUrl = URL.createObjectURL(fileToDownload);
  }

  const linkElement = document.createElement("a");
  linkElement.href = fileUrl;
  linkElement.download = filename;
  linkElement.style.display = "none";
  document.body.appendChild(linkElement);
  linkElement.click();
  document.body.removeChild(linkElement);

  if (typeof fileOrUrl !== "string") {
    URL.revokeObjectURL(fileUrl);
  }
}

export type DownloadedFile = { file: ArrayBuffer; filename: string };
const handleDownloadedFile = async (
  call: () => Promise<AxiosResponse<ArrayBuffer>>,
  filename: string
): Promise<DownloadedFile | null> => {
  try {
    const response = await call();
    return {
      file: response.data,
      filename,
    };
  } catch (error) {
    handleGatewayError({
      onResponse: (e) => {
        if (e.response.status === 403) {
          displayErrorToast("Vous n'avez pas accès à ce fichier");
        }
        displayErrorToast(
          "Une erreur est survenue lors du téléchargement du fichier"
        );
      },
      onUnhandled: () => {
        displayErrorToast(
          "Une erreur est survenue lors du téléchargement du fichier"
        );
      },
    })(error);
    return null;
  }
};

export const getDownloadedFile = async (
  siren: string,
  millesime: number,
  pathname: string,
  filename: string,
  idAdmin = false
): Promise<DownloadedFile | null> => {
  return handleDownloadedFile(
    () =>
      userSession.axiosInstance.get<ArrayBuffer>(
        `/documents/${siren}${
          idAdmin ? "" : `/user/${millesime}`
        }?pathname=${encodeURIComponent(pathname)}`,
        {
          responseType: "blob",
        }
      ),
    filename
  );
};
export const getDownloadedFileAdmin = async (
  siren: string,
  pathname: string,
  filename: string
): Promise<DownloadedFile | null> => {
  return handleDownloadedFile(
    () =>
      userSession.axiosInstance.get<ArrayBuffer>(
        `/documents/${siren}?pathname=${encodeURIComponent(pathname)}`,
        {
          responseType: "blob",
        }
      ),
    filename
  );
};
